import React from "react";
import "./StorageHeader.scss";
import SearchBar from "components/search/SearchBar/SearchBar";
import { getHeadingByLevel } from "components/core/Typography";
import HeaderImage from "assets/images/psp_search_bg.svg";
import PropTypes from "prop-types";

const StorageHeader = ({ heading, searchIn, level = "4" }) => {
	const HeadingTag = getHeadingByLevel(level);

	return (
		<div>
			<div className="searchbar-container">
				<SearchBar
					buttonText="Search for Storage"
					id="hero-search-bar"
					label="Search by city, state, or zip"
					theme="transparnet"
					className="rv-serach-bar"
					searchIn={searchIn}
				>
					<HeadingTag
						weight="bold"
						size="xxlarge"
						largeSize="large"
						align="center"
						color="white"
					>
						{heading}
					</HeadingTag>
				</SearchBar>
			</div>
			<img
				src={HeaderImage}
				alt=""
				className="psp-header-image"
				width="1272"
				height="325"
			/>
		</div>
	);
};

StorageHeader.propTypes = {
	heading: PropTypes.string,
	searchIn: PropTypes.string,
	level: PropTypes.string
};

export default StorageHeader;
